import { ORGANIZATION_CONFIG_SET } from './constants';
import { OrganizationConfig, SetOrganizationConfigAction } from './types';

export function setOrganizationConfig(
    organizationConfig: OrganizationConfig
): SetOrganizationConfigAction {
    return {
        type: ORGANIZATION_CONFIG_SET,
        payload: organizationConfig
    };
}
